/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */


 $( document ).ready(function() {
     
  var pageNav = $("#pageNav").children("ol").first();
  var sections = $("#our-story").children("section");
  $.each(sections, function(index,value) {
    var secId = $(value).attr("id");
    var tmp = "<li><a class='pageNav-link pageNav-link-"+ index +"' href='#"+secId+"'></a></li>";
    $(pageNav).append(tmp);
  });
  
  $(".pageNav-link").on("click", function(a) {
    a.preventDefault();
    $('.pageNav-link').removeClass("active");
    $(a?.target).addClass("active");
  });
  
  if (document.getElementsByClassName('ProductVariants__Container').length > 0) {
    addHoverEventListener()
  }

  if($("#our-story").length > 0) {
    $(window).on('resize scroll', function() {
      let alreadyActive = false
      $('#our-story section').each(function(i) {
        if (!alreadyActive) {
          if (isInViewport($(this))) {
            $('.pageNav-link-' + i).addClass('active')
            alreadyActive = true
          } else {
            $('.pageNav-link-' + i).removeClass('active')
          }
        } else {
          $('.pageNav-link-' + i).removeClass('active')
        }
        
      })
      alreadyActive = false
    })
  }

});


const addHoverEventListener = function () {
  $(".ProductVariants__Container a").hover(function(i) {
    if (i.handleObj.origType === 'mouseenter') {
      $(`.Product_ID--${i.target.dataset.targetId} .ProductItem__Image--alternate`).hide()
      $(`.Product_ID--${i.target.dataset.targetId} .ProductItem__Image--variant`).attr('srcset', i.target.dataset.srcset).attr('data-image-id', i.target.dataset.imageId).attr('data-srcset', i.target.dataset.srcset).attr('src', i.target.dataset.srcset)
      $(`.Product_ID--${i.target.dataset.targetId} .ProductItem__Image--default`).css('opacity', 0)
    } else {
      $('.ProductItem__Image--default').css('opacity', 1)
      $(`.Product_ID--${i.target.dataset.targetId} .ProductItem__Image--alternate`).show()
    }
  })
}

const isInViewport = function(elm) {
  var elementTop = elm.offset().top;
  var elementBottom = elementTop + elm.outerHeight();

  var viewportTop = $(window).scrollTop();
  var viewportBottom = viewportTop + $(window).height();

  return elementBottom > viewportTop && elementTop < viewportBottom;
}

// function($){
//     $(function(){  //document.ready
// 		alert("here");
//         //DOM READY code here

//       var pageNav = document.getElementById("pageNav");
//       var sectionLength = pageNav.childNodes.length;
//       console.log(pageNav);
//       console.log(sectionLength);
  
//     });

//     //Functions, Plugins, Etc.. Here
//     //(does not wait for DOM READY STATE) 

// })(jQuery);